const libBuilder = [
    {
        path: '/libraryBuilder',
        name: 'libraryBuilder',
        meta:{
            login:"no"
        },
        component: () => import('@/views/libraryBuilder/BuilderIndex.vue'),
    },
]

export default libBuilder
